import { action, observable, runInAction } from 'mobx';
// import cloneDeep from 'lodash/cloneDeep';

import { ErrorInterface } from 'modules/core/api/globalApi';
import { tireStorageV2Controller } from './tireStorageV2Controller';
import {
  TireBrandV2Interface,
  TireModelV2Interface,
  UpdateTireBrandRequestInterface,
  UpdateTireModelRequestInterface,
  TireBrandCategoryInterface,
  // AddNewTireBrandRequestInterface,
  // AddNewTireModelRequestInterface,
} from '../api/tireStorageApi';

/* type TireModelsCacheType = {
  tireModels: TireModelV2Interface[],
  brandId: number,
}; */
export interface TireStorageV2Store {
  tireBrands: TireBrandV2Interface[],
  tireModels: TireModelV2Interface[],
  tireModelsByBrandId: number

  selectedTireBrand: TireBrandV2Interface,
  selectedTireModel: TireModelV2Interface,
  tireBrandCategories: TireBrandCategoryInterface[],
  tireBrandCategoriesByBrandId: number,

  // axle1TireModels: TireModelV2Interface[], // для 1-ой оси модели шин
  // axle2TireModels: TireModelV2Interface[], // для 2-ой оси модели шин
  // axle1TireModelByBrandId: number,
  // axle2TireModelByBrandId: number,
  // tireModelsCache: TireModelsCacheType[],
  error: ErrorInterface,
}

export const tireStorageV2Store: TireStorageV2Store = observable({
  tireBrands: [],
  tireModels: [],
  tireModelsByBrandId: undefined,
  tireBrandCategories: [],
  tireBrandCategoriesByBrandId: null,
  // axle1TireModels: [],
  // axle2TireModels: [],
  // axle1TireModelByBrandId: undefined,
  // axle2TireModelByBrandId: undefined,
  // tireModelsCache: [],
  error: null,
} as TireStorageV2Store);

export const tireStorageV2Actions = {

  // Новый STORE для шин с поддрежкой 1С
  // 26.11.2024 на совещании с Николаем решили, что справочники марок и моделей шин будем заводить через 1С

  clearError: action(() => {
    tireStorageV2Store.error = null;
  }),

  getTireBrands: async (): Promise<void> => {
    if (tireStorageV2Store.tireBrands.length === 0) {
      tireStorageV2Store.error = null;
      const response = await tireStorageV2Controller.getTireBrands(false);
      tireStorageV2Actions.handleError(response);
      runInAction(() => { tireStorageV2Store.tireBrands = response.data; });
    }
  },

  updateTireBrand: async (request: UpdateTireBrandRequestInterface): Promise<number> => {
    const response = await tireStorageV2Controller.updateTireBrand(request);
    if (response.errorData) {
      tireStorageV2Actions.handleError(response);
      return response;
    }

    const y = [ ... tireStorageV2Store.tireBrands ];
    const x = y.findIndex((v)=> v.id === request.id);
    if (x >= 0) {
      y[x] = { ... y[x], ...response.data };
    }

    runInAction(() => { tireStorageV2Store.tireBrands = y; });
    tireStorageV2Actions.setSelectedTireBrand(response.data);
    return response;
  },

  getTireModels: async (brandId: number): Promise<void> => {
    tireStorageV2Store.error = null;
    runInAction(() => { tireStorageV2Store.tireModelsByBrandId = brandId; });
    const response = await tireStorageV2Controller.getTireModels(false, brandId);
    tireStorageV2Actions.handleError(response);
    runInAction(() => { tireStorageV2Store.tireModels = response.data; });
  },

  updateTireModel: async (request: UpdateTireModelRequestInterface): Promise<number> => {
    const response = await tireStorageV2Controller.updateTireModel(request);
    if (response.errorData) {
      tireStorageV2Actions.handleError(response);
      return response;
    }

    const y = [ ... tireStorageV2Store.tireModels ];
    const x = y.findIndex((v)=> v.id === request.id);
    if (x >= 0) {
      y[x] = { ... y[x], ...response.data };
    }
    runInAction(() => { tireStorageV2Store.tireModels = y; });
    return response;
  },

  getTireBrandCategories: async (brandId: number): Promise<void> => {
    tireStorageV2Store.error = null;
    runInAction(() => { 
      tireStorageV2Store.tireBrandCategoriesByBrandId = brandId; 
    });      
    const response = await tireStorageV2Controller.getTireBrandCategories(brandId);
    tireStorageV2Actions.handleError(response);
    if (!response.errorData) {
      runInAction(() => { tireStorageV2Store.tireBrandCategories = response.data; });
    }
    else {
      runInAction(() => { 
        tireStorageV2Store.tireBrandCategories = []; 
        tireStorageV2Store.tireBrandCategoriesByBrandId = null; 
      });
    }    
  },

  /*   addNewTireBrand: async (request: AddNewTireBrandRequestInterface): Promise<number> => {
    const response = await tireStorageController.addNewTireBrand(request);
    if (response.errorData) {
      tireStorageActions.handleError(response);
      return 0;
    }
    tireStorageStore.tireBrands = [...tireStorageStore.tireBrands, response.data];
    return response?.data?.id;
  },

  getTireModels: async (
    brandId: number,
    tireModelsField: string,
    tireModelByBrandIdField: string
  ): Promise<void> => {
    tireStorageStore.error = null;
    runInAction(() => { tireStorageStore[tireModelByBrandIdField] = brandId; });
    const tireModels = tireStorageStore.tireModelsCache.find(v => v.brandId === brandId)?.tireModels ?? null;
    if (tireModels) {
      runInAction(() => { tireStorageStore[tireModelsField] = cloneDeep(tireModels); });
    } else {
      const response = await tireStorageController.getTireModelsResponse(false, brandId);
      if (response.errorData) {
        tireStorageActions.handleError(response);
        tireStorageActions.clearTireModels(tireModelsField, tireModelByBrandIdField);
      } else {
        runInAction(() => { tireStorageStore[tireModelsField] = response.data; });
        tireStorageStore.tireModelsCache.push({ tireModels: response.data, brandId });
      }
    }
  },

  addNewTireModel: async (
    request: AddNewTireModelRequestInterface,
    tireModelsField: string
  ): Promise<number> => {
    const response = await tireStorageController.addNewTireModel(request);
    if (response.errorData) {
      tireStorageActions.handleError(response);
      return 0;
    }
    tireStorageStore[tireModelsField] = [...tireStorageStore[tireModelsField], response.data];
    // в кеше обновим данные:
    tireStorageStore.tireModelsCache = tireStorageStore.tireModelsCache.filter(v => v.brandId !== request.tireBrandId);
    tireStorageStore.tireModelsCache.push({
      tireModels: tireStorageStore[tireModelsField],
      brandId: request.tireBrandId,
    });
    // конец обновления кеша
    return response?.data?.id;
  },

  clearTireModels: action((
    tireModelsField: string,
    tireModelByBrandIdField: string
  ) => {
    tireStorageStore[tireModelsField] = [];
    tireStorageStore[tireModelByBrandIdField] = null;
  }), */

  handleError: action((response) => {
    if (response.errorData) {
      const { data } = response;
      tireStorageV2Store.error = data;
      throw data;
    }
  }),

  setSelectedTireBrand: async (data: TireBrandV2Interface): Promise<void> => {
    tireStorageV2Actions.clearError();
    runInAction(() => {
      tireStorageV2Store.selectedTireBrand = data;
    });
  },

  clearSelectedTireBrand: async (): Promise<void> => {
    tireStorageV2Actions.clearError();
    runInAction(() => {
      tireStorageV2Store.selectedTireBrand = null;
    });
  },

  setSelectedTireModel: async (data: TireModelV2Interface): Promise<void> => {
    tireStorageV2Actions.clearError();
    runInAction(() => {
      tireStorageV2Store.selectedTireModel = data;
    });
  },

  clearSelectedTireModel: async (): Promise<void> => {
    tireStorageV2Actions.clearError();
    runInAction(() => {
      tireStorageV2Store.selectedTireModel = null;
    });
  },

};
